import React from 'react';
import { routes } from 'constants/config';
import Chart from 'components/Chart';
import colors from 'constants/colors';
import FilteredRequest from '../_shared/FilteredRequest';

const MonthlyActiveUsersChart = ({ i18n }) => (
  <FilteredRequest url={routes.INSIGHTS.ACTIVE_USERS.ACTIVE_USERS_OVER_TIME}>
    {({ data, error }) => (
      <div>
        {error && i18n.error}
        {!error && !data && i18n.loading}
        {!error && data && (
          <Chart
            config={{
              chart: {
                type: 'column',
                height: '25%',
              },
              legend: {
                enabled: false,
              },
              xAxis: {
                type: 'datetime',
                dateTimeLabelFormats: {
                  month: '%b',
                },
                // Make the data fill the entire axis
                minPadding: 0,
                maxPadding: 0,
              },
              yAxis: {
                // Show only the minimum and maximum values on the scale
                tickAmount: 2,
                // There are no fractional people
                allowDecimals: false,
              },
              series: [
                // I would like to avoid manually parsing the dates to the JS
                // timestamps Highcharts expects, but can’t figure out how.
                {
                  name: i18n.active_users.monthly_counts.title,
                  data: data.monthly_active_user_counts.map(point => [
                    Date.parse(point[0]),
                    point[1],
                  ]),
                  color: colors.RED_DARK,
                },
              ],
            }}
          />
        )}
      </div>
    )}
  </FilteredRequest>
);

export default MonthlyActiveUsersChart;
